import React from 'react';
import * as util from '#packages/util';
import type { StateMapperArgs } from 'types/redux';
import type { LassoCandidate } from '#packages/stateManagement';
import styles from './lasso.scss';

interface LassoOwnProps {
  onMouseMove: (event: React.MouseEvent) => void;
  onMouseDown: (event: React.MouseEvent) => void;
  onMouseUp: (event: React.MouseEvent) => void;
}

interface LassoStateProps {
  lassoLayout: AnyFixMe;
  lassoCandidates: LassoCandidateWithInfo[];
  isFixedStage: boolean;
}

interface LassoProps extends LassoOwnProps, LassoStateProps {}

const Lasso: React.FC<LassoProps> = (props) => {
  if (!props.lassoLayout) {
    return null;
  }
  const lassoComponent = (
    <div className={styles.lassoLayer}>
      <svg className={styles.lassoHighlights}>
        <rect
          {...props.lassoLayout}
          className={util.cx(props.lassoLayout?.className, styles.lassoRect)}
        />
        {props.lassoCandidates.map(
          (candidateComponent, candidateComponentIndex) => (
            <rect
              key={candidateComponentIndex}
              {...candidateComponent.layout.bounding}
              className={util.cx(
                candidateComponent.layout.bounding?.className,
                styles.lassoCandidate,
                {
                  [styles.showOnAllPages]: candidateComponent.showOnAllPages,
                },
              )}
            />
          ),
        )}
      </svg>
    </div>
  );
  if (props.isFixedStage) {
    return (
      <div
        className={styles.lassoWrapper}
        onMouseDown={props.onMouseDown}
        onMouseMove={props.onMouseMove}
        onMouseUp={props.onMouseUp}
      >
        {lassoComponent}
      </div>
    );
  }
  return lassoComponent;
};

type LassoCandidateWithInfo = LassoCandidate & { showOnAllPages: boolean };

const mapStateToProps = ({
  editorAPI,
  state: editorState,
}: StateMapperArgs): LassoStateProps => {
  const { lassoLayout } = editorState;
  const lassoCandidates = (editorState.lassoCandidates || []).map(
    (candidate) => ({
      ...candidate,
      showOnAllPages: editorAPI.components.isShowOnAllPages(
        candidate.component,
      ),
    }),
  );
  const isFixedStage = util.fixedStage.isFixedStageEnabled();

  return { lassoLayout, lassoCandidates, isFixedStage };
};

export default util.hoc.connect(
  util.hoc.STORES.MOUSE_OPS,
  mapStateToProps,
)(Lasso);
